<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <div class="clearfix">
            <h1 class="float-left display-3 mr-4">404</h1>
            <h4 class="pt-3">Oops! You're lost.</h4>
            <p class="text-muted">The page you are looking for was not found.</p>
            <p class="text-muted"><a v-bind:href="'#/dashboard-'+ page">Back to home.</a></p>
          </div>
        
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

  import interfaces from '@/templates/_interfaces.js'
  import axios from 'axios'
  import VueNotifications from 'vue-notifications'

  export default {
    name: 'NotFound',
    data ()  {
      return {
       page: '',
       LoginForm: {
          username: null,
          password: null
        }

      }
    },
    notifications: {
      showErrorNotification: {
        title: 'Error Title',
        message: 'Messages',
        type: 'error'
      },
      showInfoNotification: {
        title: 'Info Title',
        message: 'Messages',
        type: 'info'
      }
    },
    methods: {
      init: function() {
        this.page = localStorage.getItem("start_page");
      }
    },
    mounted () {
      this.init()
    }
  }

</script>

  